module.exports = __webpack_public_path__ + "static/media/car-delivery.1c02c1af.svg";